<div class="main-content">
  <div
    class="bottom-half-of-card"
    [style.background-color]="viewModel.cardColor$ | push"
    [style.height.px]="viewModel.bottomHeight$ | push"></div>
</div>
